
/*!
 * Font Awesome Free 6.0.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */ function $3f9c89d5bd82c63b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3f9c89d5bd82c63b$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3f9c89d5bd82c63b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3f9c89d5bd82c63b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3f9c89d5bd82c63b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3f9c89d5bd82c63b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3f9c89d5bd82c63b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3f9c89d5bd82c63b$var$_typeof(obj);
}
function $3f9c89d5bd82c63b$var$_wrapRegExp() {
    $3f9c89d5bd82c63b$var$_wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $3f9c89d5bd82c63b$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return $3f9c89d5bd82c63b$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $3f9c89d5bd82c63b$var$_wrapRegExp.apply(this, arguments);
}
function $3f9c89d5bd82c63b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3f9c89d5bd82c63b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3f9c89d5bd82c63b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3f9c89d5bd82c63b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3f9c89d5bd82c63b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3f9c89d5bd82c63b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3f9c89d5bd82c63b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3f9c89d5bd82c63b$var$_setPrototypeOf(subClass, superClass);
}
function $3f9c89d5bd82c63b$var$_setPrototypeOf(o, p) {
    $3f9c89d5bd82c63b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3f9c89d5bd82c63b$var$_setPrototypeOf(o, p);
}
function $3f9c89d5bd82c63b$var$_slicedToArray(arr, i) {
    return $3f9c89d5bd82c63b$var$_arrayWithHoles(arr) || $3f9c89d5bd82c63b$var$_iterableToArrayLimit(arr, i) || $3f9c89d5bd82c63b$var$_unsupportedIterableToArray(arr, i) || $3f9c89d5bd82c63b$var$_nonIterableRest();
}
function $3f9c89d5bd82c63b$var$_toConsumableArray(arr) {
    return $3f9c89d5bd82c63b$var$_arrayWithoutHoles(arr) || $3f9c89d5bd82c63b$var$_iterableToArray(arr) || $3f9c89d5bd82c63b$var$_unsupportedIterableToArray(arr) || $3f9c89d5bd82c63b$var$_nonIterableSpread();
}
function $3f9c89d5bd82c63b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3f9c89d5bd82c63b$var$_arrayLikeToArray(arr);
}
function $3f9c89d5bd82c63b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3f9c89d5bd82c63b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3f9c89d5bd82c63b$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3f9c89d5bd82c63b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3f9c89d5bd82c63b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3f9c89d5bd82c63b$var$_arrayLikeToArray(o, minLen);
}
function $3f9c89d5bd82c63b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3f9c89d5bd82c63b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3f9c89d5bd82c63b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $3f9c89d5bd82c63b$var$noop = function noop() {};
var $3f9c89d5bd82c63b$var$_WINDOW = {};
var $3f9c89d5bd82c63b$var$_DOCUMENT = {};
var $3f9c89d5bd82c63b$var$_MUTATION_OBSERVER = null;
var $3f9c89d5bd82c63b$var$_PERFORMANCE = {
    mark: $3f9c89d5bd82c63b$var$noop,
    measure: $3f9c89d5bd82c63b$var$noop
};
try {
    if (typeof window !== 'undefined') $3f9c89d5bd82c63b$var$_WINDOW = window;
    if (typeof document !== 'undefined') $3f9c89d5bd82c63b$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $3f9c89d5bd82c63b$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $3f9c89d5bd82c63b$var$_PERFORMANCE = performance;
} catch (e) {}
var $3f9c89d5bd82c63b$var$_ref = $3f9c89d5bd82c63b$var$_WINDOW.navigator || {}, $3f9c89d5bd82c63b$var$_ref$userAgent = $3f9c89d5bd82c63b$var$_ref.userAgent, $3f9c89d5bd82c63b$var$userAgent = $3f9c89d5bd82c63b$var$_ref$userAgent === void 0 ? '' : $3f9c89d5bd82c63b$var$_ref$userAgent;
var $3f9c89d5bd82c63b$var$WINDOW = $3f9c89d5bd82c63b$var$_WINDOW;
var $3f9c89d5bd82c63b$var$DOCUMENT = $3f9c89d5bd82c63b$var$_DOCUMENT;
var $3f9c89d5bd82c63b$var$MUTATION_OBSERVER = $3f9c89d5bd82c63b$var$_MUTATION_OBSERVER;
var $3f9c89d5bd82c63b$var$PERFORMANCE = $3f9c89d5bd82c63b$var$_PERFORMANCE;
var $3f9c89d5bd82c63b$var$IS_BROWSER = !!$3f9c89d5bd82c63b$var$WINDOW.document;
var $3f9c89d5bd82c63b$var$IS_DOM = !!$3f9c89d5bd82c63b$var$DOCUMENT.documentElement && !!$3f9c89d5bd82c63b$var$DOCUMENT.head && typeof $3f9c89d5bd82c63b$var$DOCUMENT.addEventListener === 'function' && typeof $3f9c89d5bd82c63b$var$DOCUMENT.createElement === 'function';
var $3f9c89d5bd82c63b$var$IS_IE = ~$3f9c89d5bd82c63b$var$userAgent.indexOf('MSIE') || ~$3f9c89d5bd82c63b$var$userAgent.indexOf('Trident/');
var $3f9c89d5bd82c63b$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var $3f9c89d5bd82c63b$var$UNITS_IN_GRID = 16;
var $3f9c89d5bd82c63b$var$DEFAULT_FAMILY_PREFIX = 'fa';
var $3f9c89d5bd82c63b$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var $3f9c89d5bd82c63b$var$DATA_FA_I2SVG = 'data-fa-i2svg';
var $3f9c89d5bd82c63b$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var $3f9c89d5bd82c63b$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var $3f9c89d5bd82c63b$var$DATA_PREFIX = 'data-prefix';
var $3f9c89d5bd82c63b$var$DATA_ICON = 'data-icon';
var $3f9c89d5bd82c63b$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var $3f9c89d5bd82c63b$var$MUTATION_APPROACH_ASYNC = 'async';
var $3f9c89d5bd82c63b$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
var $3f9c89d5bd82c63b$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $3f9c89d5bd82c63b$var$PREFIX_TO_STYLE = {
    'fas': 'solid',
    'fa-solid': 'solid',
    'far': 'regular',
    'fa-regular': 'regular',
    'fal': 'light',
    'fa-light': 'light',
    'fat': 'thin',
    'fa-thin': 'thin',
    'fad': 'duotone',
    'fa-duotone': 'duotone',
    'fab': 'brands',
    'fa-brands': 'brands',
    'fak': 'kit',
    'fa-kit': 'kit',
    'fa': 'solid'
};
var $3f9c89d5bd82c63b$var$STYLE_TO_PREFIX = {
    'solid': 'fas',
    'regular': 'far',
    'light': 'fal',
    'thin': 'fat',
    'duotone': 'fad',
    'brands': 'fab',
    'kit': 'fak'
};
var $3f9c89d5bd82c63b$var$PREFIX_TO_LONG_STYLE = {
    'fab': 'fa-brands',
    'fad': 'fa-duotone',
    'fak': 'fa-kit',
    'fal': 'fa-light',
    'far': 'fa-regular',
    'fas': 'fa-solid',
    'fat': 'fa-thin'
};
var $3f9c89d5bd82c63b$var$LONG_STYLE_TO_PREFIX = {
    'fa-brands': 'fab',
    'fa-duotone': 'fad',
    'fa-kit': 'fak',
    'fa-light': 'fal',
    'fa-regular': 'far',
    'fa-solid': 'fas',
    'fa-thin': 'fat'
};
var $3f9c89d5bd82c63b$var$ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk\-\ ]/; // eslint-disable-line no-useless-escape
var $3f9c89d5bd82c63b$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var $3f9c89d5bd82c63b$var$FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?
var $3f9c89d5bd82c63b$var$FONT_WEIGHT_TO_PREFIX = {
    '900': 'fas',
    '400': 'far',
    'normal': 'far',
    '300': 'fal',
    '100': 'fat'
};
var $3f9c89d5bd82c63b$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $3f9c89d5bd82c63b$var$oneToTwenty = $3f9c89d5bd82c63b$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $3f9c89d5bd82c63b$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
var $3f9c89d5bd82c63b$var$DUOTONE_CLASSES = {
    GROUP: 'duotone-group',
    SWAP_OPACITY: 'swap-opacity',
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
};
var $3f9c89d5bd82c63b$var$RESERVED_CLASSES = [].concat($3f9c89d5bd82c63b$var$_toConsumableArray(Object.keys($3f9c89d5bd82c63b$var$STYLE_TO_PREFIX)), [
    '2xs',
    'xs',
    'sm',
    'lg',
    'xl',
    '2xl',
    'beat',
    'border',
    'fade',
    'beat-fade',
    'bounce',
    'flip-both',
    'flip-horizontal',
    'flip-vertical',
    'flip',
    'fw',
    'inverse',
    'layers-counter',
    'layers-text',
    'layers',
    'li',
    'pull-left',
    'pull-right',
    'pulse',
    'rotate-180',
    'rotate-270',
    'rotate-90',
    'rotate-by',
    'shake',
    'spin-pulse',
    'spin-reverse',
    'spin',
    'stack-1x',
    'stack-2x',
    'stack',
    'ul',
    $3f9c89d5bd82c63b$var$DUOTONE_CLASSES.GROUP,
    $3f9c89d5bd82c63b$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $3f9c89d5bd82c63b$var$DUOTONE_CLASSES.PRIMARY,
    $3f9c89d5bd82c63b$var$DUOTONE_CLASSES.SECONDARY
]).concat($3f9c89d5bd82c63b$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($3f9c89d5bd82c63b$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $3f9c89d5bd82c63b$var$initial = $3f9c89d5bd82c63b$var$WINDOW.FontAwesomeConfig || {};
function $3f9c89d5bd82c63b$var$getAttrConfig(attr) {
    var element = $3f9c89d5bd82c63b$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $3f9c89d5bd82c63b$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    // For example <script data-search-pseudo-elements src="..."></script>
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($3f9c89d5bd82c63b$var$DOCUMENT && typeof $3f9c89d5bd82c63b$var$DOCUMENT.querySelector === 'function') {
    var $3f9c89d5bd82c63b$var$attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-auto-a11y',
            'autoA11y'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    $3f9c89d5bd82c63b$var$attrs.forEach(function(_ref) {
        var _ref2 = $3f9c89d5bd82c63b$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $3f9c89d5bd82c63b$var$coerce($3f9c89d5bd82c63b$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $3f9c89d5bd82c63b$var$initial[key] = val;
    });
}
var $3f9c89d5bd82c63b$var$_default = {
    familyPrefix: $3f9c89d5bd82c63b$var$DEFAULT_FAMILY_PREFIX,
    styleDefault: 'solid',
    replacementClass: $3f9c89d5bd82c63b$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
var $3f9c89d5bd82c63b$var$_config = $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, $3f9c89d5bd82c63b$var$_default), $3f9c89d5bd82c63b$var$initial);
if (!$3f9c89d5bd82c63b$var$_config.autoReplaceSvg) $3f9c89d5bd82c63b$var$_config.observeMutations = false;
var $3f9c89d5bd82c63b$var$config = {};
Object.keys($3f9c89d5bd82c63b$var$_config).forEach(function(key) {
    Object.defineProperty($3f9c89d5bd82c63b$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $3f9c89d5bd82c63b$var$_config[key] = val;
            $3f9c89d5bd82c63b$var$_onChangeCb.forEach(function(cb) {
                return cb($3f9c89d5bd82c63b$var$config);
            });
        },
        get: function get() {
            return $3f9c89d5bd82c63b$var$_config[key];
        }
    });
});
$3f9c89d5bd82c63b$var$WINDOW.FontAwesomeConfig = $3f9c89d5bd82c63b$var$config;
var $3f9c89d5bd82c63b$var$_onChangeCb = [];
function $3f9c89d5bd82c63b$var$onChange(cb) {
    $3f9c89d5bd82c63b$var$_onChangeCb.push(cb);
    return function() {
        $3f9c89d5bd82c63b$var$_onChangeCb.splice($3f9c89d5bd82c63b$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $3f9c89d5bd82c63b$var$d = $3f9c89d5bd82c63b$var$UNITS_IN_GRID;
var $3f9c89d5bd82c63b$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $3f9c89d5bd82c63b$var$insertCss(css) {
    if (!css || !$3f9c89d5bd82c63b$var$IS_DOM) return;
    var style = $3f9c89d5bd82c63b$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = $3f9c89d5bd82c63b$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $3f9c89d5bd82c63b$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $3f9c89d5bd82c63b$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $3f9c89d5bd82c63b$var$nextUniqueId() {
    var size = 12;
    var id = '';
    while(size-- > 0)id += $3f9c89d5bd82c63b$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $3f9c89d5bd82c63b$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $3f9c89d5bd82c63b$var$classArray(node) {
    if (node.classList) return $3f9c89d5bd82c63b$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter(function(i) {
        return i;
    });
}
function $3f9c89d5bd82c63b$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $3f9c89d5bd82c63b$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, "=\"").concat($3f9c89d5bd82c63b$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $3f9c89d5bd82c63b$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $3f9c89d5bd82c63b$var$transformIsMeaningful(transform) {
    return transform.size !== $3f9c89d5bd82c63b$var$meaninglessTransform.size || transform.x !== $3f9c89d5bd82c63b$var$meaninglessTransform.x || transform.y !== $3f9c89d5bd82c63b$var$meaninglessTransform.y || transform.rotate !== $3f9c89d5bd82c63b$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $3f9c89d5bd82c63b$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $3f9c89d5bd82c63b$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $3f9c89d5bd82c63b$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $3f9c89d5bd82c63b$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = '';
    if (startCentered && $3f9c89d5bd82c63b$var$IS_IE) val += "translate(".concat(transform.x / $3f9c89d5bd82c63b$var$d - width / 2, "em, ").concat(transform.y / $3f9c89d5bd82c63b$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $3f9c89d5bd82c63b$var$d, "em), calc(-50% + ").concat(transform.y / $3f9c89d5bd82c63b$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $3f9c89d5bd82c63b$var$d, "em, ").concat(transform.y / $3f9c89d5bd82c63b$var$d, "em) ");
    val += "scale(".concat(transform.size / $3f9c89d5bd82c63b$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $3f9c89d5bd82c63b$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $3f9c89d5bd82c63b$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";
function $3f9c89d5bd82c63b$var$css() {
    var dfp = $3f9c89d5bd82c63b$var$DEFAULT_FAMILY_PREFIX;
    var drc = $3f9c89d5bd82c63b$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $3f9c89d5bd82c63b$var$config.familyPrefix;
    var rc = $3f9c89d5bd82c63b$var$config.replacementClass;
    var s = $3f9c89d5bd82c63b$var$baseStyles;
    if (fp !== dfp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
        var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
        var rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $3f9c89d5bd82c63b$var$_cssInserted = false;
function $3f9c89d5bd82c63b$var$ensureCss() {
    if ($3f9c89d5bd82c63b$var$config.autoAddCss && !$3f9c89d5bd82c63b$var$_cssInserted) {
        $3f9c89d5bd82c63b$var$insertCss($3f9c89d5bd82c63b$var$css());
        $3f9c89d5bd82c63b$var$_cssInserted = true;
    }
}
var $3f9c89d5bd82c63b$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $3f9c89d5bd82c63b$var$css,
                insertCss: $3f9c89d5bd82c63b$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $3f9c89d5bd82c63b$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $3f9c89d5bd82c63b$var$ensureCss();
            }
        };
    }
};
var $3f9c89d5bd82c63b$var$w = $3f9c89d5bd82c63b$var$WINDOW || {};
if (!$3f9c89d5bd82c63b$var$w[$3f9c89d5bd82c63b$var$NAMESPACE_IDENTIFIER]) $3f9c89d5bd82c63b$var$w[$3f9c89d5bd82c63b$var$NAMESPACE_IDENTIFIER] = {};
if (!$3f9c89d5bd82c63b$var$w[$3f9c89d5bd82c63b$var$NAMESPACE_IDENTIFIER].styles) $3f9c89d5bd82c63b$var$w[$3f9c89d5bd82c63b$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$3f9c89d5bd82c63b$var$w[$3f9c89d5bd82c63b$var$NAMESPACE_IDENTIFIER].hooks) $3f9c89d5bd82c63b$var$w[$3f9c89d5bd82c63b$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$3f9c89d5bd82c63b$var$w[$3f9c89d5bd82c63b$var$NAMESPACE_IDENTIFIER].shims) $3f9c89d5bd82c63b$var$w[$3f9c89d5bd82c63b$var$NAMESPACE_IDENTIFIER].shims = [];
var $3f9c89d5bd82c63b$var$namespace = $3f9c89d5bd82c63b$var$w[$3f9c89d5bd82c63b$var$NAMESPACE_IDENTIFIER];
var $3f9c89d5bd82c63b$var$functions = [];
var $3f9c89d5bd82c63b$var$listener = function listener() {
    $3f9c89d5bd82c63b$var$DOCUMENT.removeEventListener('DOMContentLoaded', listener);
    $3f9c89d5bd82c63b$var$loaded = 1;
    $3f9c89d5bd82c63b$var$functions.map(function(fn) {
        return fn();
    });
};
var $3f9c89d5bd82c63b$var$loaded = false;
if ($3f9c89d5bd82c63b$var$IS_DOM) {
    $3f9c89d5bd82c63b$var$loaded = ($3f9c89d5bd82c63b$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($3f9c89d5bd82c63b$var$DOCUMENT.readyState);
    if (!$3f9c89d5bd82c63b$var$loaded) $3f9c89d5bd82c63b$var$DOCUMENT.addEventListener('DOMContentLoaded', $3f9c89d5bd82c63b$var$listener);
}
function $3f9c89d5bd82c63b$var$domready(fn) {
    if (!$3f9c89d5bd82c63b$var$IS_DOM) return;
    $3f9c89d5bd82c63b$var$loaded ? setTimeout(fn, 0) : $3f9c89d5bd82c63b$var$functions.push(fn);
}
function $3f9c89d5bd82c63b$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === 'string') return $3f9c89d5bd82c63b$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($3f9c89d5bd82c63b$var$joinAttributes(attributes), ">").concat(children.map($3f9c89d5bd82c63b$var$toHtml).join(''), "</").concat(tag, ">");
}
function $3f9c89d5bd82c63b$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $3f9c89d5bd82c63b$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $3f9c89d5bd82c63b$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $3f9c89d5bd82c63b$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $3f9c89d5bd82c63b$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $3f9c89d5bd82c63b$var$toHex(unicode) {
    var decoded = $3f9c89d5bd82c63b$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $3f9c89d5bd82c63b$var$codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $3f9c89d5bd82c63b$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $3f9c89d5bd82c63b$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $3f9c89d5bd82c63b$var$normalizeIcons(icons);
    if (typeof $3f9c89d5bd82c63b$var$namespace.hooks.addPack === 'function' && !skipHooks) $3f9c89d5bd82c63b$var$namespace.hooks.addPack(prefix, $3f9c89d5bd82c63b$var$normalizeIcons(icons));
    else $3f9c89d5bd82c63b$var$namespace.styles[prefix] = $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, $3f9c89d5bd82c63b$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $3f9c89d5bd82c63b$var$defineIcons('fa', icons);
}
var $3f9c89d5bd82c63b$var$duotonePathRe = [
    /*#__PURE__*/ $3f9c89d5bd82c63b$var$_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $3f9c89d5bd82c63b$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $3f9c89d5bd82c63b$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var $3f9c89d5bd82c63b$var$styles = $3f9c89d5bd82c63b$var$namespace.styles, $3f9c89d5bd82c63b$var$shims = $3f9c89d5bd82c63b$var$namespace.shims;
var $3f9c89d5bd82c63b$var$LONG_STYLE = Object.values($3f9c89d5bd82c63b$var$PREFIX_TO_LONG_STYLE);
var $3f9c89d5bd82c63b$var$_defaultUsablePrefix = null;
var $3f9c89d5bd82c63b$var$_byUnicode = {};
var $3f9c89d5bd82c63b$var$_byLigature = {};
var $3f9c89d5bd82c63b$var$_byOldName = {};
var $3f9c89d5bd82c63b$var$_byOldUnicode = {};
var $3f9c89d5bd82c63b$var$_byAlias = {};
var $3f9c89d5bd82c63b$var$PREFIXES = Object.keys($3f9c89d5bd82c63b$var$PREFIX_TO_STYLE);
function $3f9c89d5bd82c63b$var$isReserved(name) {
    return ~$3f9c89d5bd82c63b$var$RESERVED_CLASSES.indexOf(name);
}
function $3f9c89d5bd82c63b$var$getIconName(familyPrefix, cls) {
    var parts = cls.split('-');
    var prefix = parts[0];
    var iconName = parts.slice(1).join('-');
    if (prefix === familyPrefix && iconName !== '' && !$3f9c89d5bd82c63b$var$isReserved(iconName)) return iconName;
    else return null;
}
var $3f9c89d5bd82c63b$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $3f9c89d5bd82c63b$var$reduce($3f9c89d5bd82c63b$var$styles, function(o, style, prefix) {
            o[prefix] = $3f9c89d5bd82c63b$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $3f9c89d5bd82c63b$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === 'number';
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $3f9c89d5bd82c63b$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === 'string';
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $3f9c89d5bd82c63b$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = 'far' in $3f9c89d5bd82c63b$var$styles || $3f9c89d5bd82c63b$var$config.autoFetchSvg;
    var shimLookups = $3f9c89d5bd82c63b$var$reduce($3f9c89d5bd82c63b$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $3f9c89d5bd82c63b$var$_byOldName = shimLookups.names;
    $3f9c89d5bd82c63b$var$_byOldUnicode = shimLookups.unicodes;
    $3f9c89d5bd82c63b$var$_defaultUsablePrefix = $3f9c89d5bd82c63b$var$getCanonicalPrefix($3f9c89d5bd82c63b$var$config.styleDefault);
};
$3f9c89d5bd82c63b$var$onChange(function(c) {
    $3f9c89d5bd82c63b$var$_defaultUsablePrefix = $3f9c89d5bd82c63b$var$getCanonicalPrefix(c.styleDefault);
});
$3f9c89d5bd82c63b$var$build();
function $3f9c89d5bd82c63b$var$byUnicode(prefix, unicode) {
    return ($3f9c89d5bd82c63b$var$_byUnicode[prefix] || {})[unicode];
}
function $3f9c89d5bd82c63b$var$byLigature(prefix, ligature) {
    return ($3f9c89d5bd82c63b$var$_byLigature[prefix] || {})[ligature];
}
function $3f9c89d5bd82c63b$var$byAlias(prefix, alias) {
    return ($3f9c89d5bd82c63b$var$_byAlias[prefix] || {})[alias];
}
function $3f9c89d5bd82c63b$var$byOldName(name) {
    return $3f9c89d5bd82c63b$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $3f9c89d5bd82c63b$var$byOldUnicode(unicode) {
    var oldUnicode = $3f9c89d5bd82c63b$var$_byOldUnicode[unicode];
    var newUnicode = $3f9c89d5bd82c63b$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $3f9c89d5bd82c63b$var$getDefaultUsablePrefix() {
    return $3f9c89d5bd82c63b$var$_defaultUsablePrefix;
}
var $3f9c89d5bd82c63b$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $3f9c89d5bd82c63b$var$getCanonicalPrefix(styleOrPrefix) {
    var style = $3f9c89d5bd82c63b$var$PREFIX_TO_STYLE[styleOrPrefix];
    var prefix = $3f9c89d5bd82c63b$var$STYLE_TO_PREFIX[styleOrPrefix] || $3f9c89d5bd82c63b$var$STYLE_TO_PREFIX[style];
    var defined = styleOrPrefix in $3f9c89d5bd82c63b$var$namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
function $3f9c89d5bd82c63b$var$getCanonicalIcon(values) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var givenPrefix = null;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = $3f9c89d5bd82c63b$var$getIconName($3f9c89d5bd82c63b$var$config.familyPrefix, cls);
        if ($3f9c89d5bd82c63b$var$styles[cls]) {
            cls = $3f9c89d5bd82c63b$var$LONG_STYLE.includes(cls) ? $3f9c89d5bd82c63b$var$LONG_STYLE_TO_PREFIX[cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($3f9c89d5bd82c63b$var$PREFIXES.indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $3f9c89d5bd82c63b$var$getCanonicalPrefix(cls);
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $3f9c89d5bd82c63b$var$config.replacementClass) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === 'fa' ? $3f9c89d5bd82c63b$var$byOldName(acc.iconName) : {};
            var aliasIconName = $3f9c89d5bd82c63b$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === 'far' && !$3f9c89d5bd82c63b$var$styles['far'] && $3f9c89d5bd82c63b$var$styles['fas'] && !$3f9c89d5bd82c63b$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = 'fas';
        }
        return acc;
    }, $3f9c89d5bd82c63b$var$emptyCanonicalIcon());
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $3f9c89d5bd82c63b$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
var $3f9c89d5bd82c63b$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $3f9c89d5bd82c63b$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $3f9c89d5bd82c63b$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $3f9c89d5bd82c63b$var$defineIcons(key, additions[key]);
                    var longPrefix = $3f9c89d5bd82c63b$var$PREFIX_TO_LONG_STYLE[key];
                    if (longPrefix) $3f9c89d5bd82c63b$var$defineIcons(longPrefix, additions[key]);
                    $3f9c89d5bd82c63b$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === 'string') additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var $3f9c89d5bd82c63b$var$_plugins = [];
var $3f9c89d5bd82c63b$var$_hooks = {};
var $3f9c89d5bd82c63b$var$providers = {};
var $3f9c89d5bd82c63b$var$defaultProviderKeys = Object.keys($3f9c89d5bd82c63b$var$providers);
function $3f9c89d5bd82c63b$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $3f9c89d5bd82c63b$var$_plugins = nextPlugins;
    $3f9c89d5bd82c63b$var$_hooks = {};
    Object.keys($3f9c89d5bd82c63b$var$providers).forEach(function(k) {
        if ($3f9c89d5bd82c63b$var$defaultProviderKeys.indexOf(k) === -1) delete $3f9c89d5bd82c63b$var$providers[k];
    });
    $3f9c89d5bd82c63b$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if ($3f9c89d5bd82c63b$var$_typeof(mixout[tk]) === 'object') Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$3f9c89d5bd82c63b$var$_hooks[hook]) $3f9c89d5bd82c63b$var$_hooks[hook] = [];
                $3f9c89d5bd82c63b$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($3f9c89d5bd82c63b$var$providers);
    });
    return obj;
}
function $3f9c89d5bd82c63b$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $3f9c89d5bd82c63b$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $3f9c89d5bd82c63b$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $3f9c89d5bd82c63b$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $3f9c89d5bd82c63b$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $3f9c89d5bd82c63b$var$providers[hook] ? $3f9c89d5bd82c63b$var$providers[hook].apply(null, args) : undefined;
}
function $3f9c89d5bd82c63b$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $3f9c89d5bd82c63b$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $3f9c89d5bd82c63b$var$byAlias(prefix, iconName) || iconName;
    return $3f9c89d5bd82c63b$var$iconFromMapping($3f9c89d5bd82c63b$var$library.definitions, prefix, iconName) || $3f9c89d5bd82c63b$var$iconFromMapping($3f9c89d5bd82c63b$var$namespace.styles, prefix, iconName);
}
var $3f9c89d5bd82c63b$var$library = new $3f9c89d5bd82c63b$var$Library();
var $3f9c89d5bd82c63b$var$noAuto = function noAuto() {
    $3f9c89d5bd82c63b$var$config.autoReplaceSvg = false;
    $3f9c89d5bd82c63b$var$config.observeMutations = false;
    $3f9c89d5bd82c63b$var$callHooks('noAuto');
};
var $3f9c89d5bd82c63b$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($3f9c89d5bd82c63b$var$IS_DOM) {
            $3f9c89d5bd82c63b$var$callHooks('beforeI2svg', params);
            $3f9c89d5bd82c63b$var$callProvided('pseudoElements2svg', params);
            return $3f9c89d5bd82c63b$var$callProvided('i2svg', params);
        } else return Promise.reject('Operation requires a DOM of some kind.');
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($3f9c89d5bd82c63b$var$config.autoReplaceSvg === false) $3f9c89d5bd82c63b$var$config.autoReplaceSvg = true;
        $3f9c89d5bd82c63b$var$config.observeMutations = true;
        $3f9c89d5bd82c63b$var$domready(function() {
            $3f9c89d5bd82c63b$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $3f9c89d5bd82c63b$var$callHooks('watch', params);
        });
    }
};
var $3f9c89d5bd82c63b$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($3f9c89d5bd82c63b$var$_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $3f9c89d5bd82c63b$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $3f9c89d5bd82c63b$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $3f9c89d5bd82c63b$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === 'string' && (_icon.indexOf("".concat($3f9c89d5bd82c63b$var$config.familyPrefix, "-")) > -1 || _icon.match($3f9c89d5bd82c63b$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $3f9c89d5bd82c63b$var$getCanonicalIcon(_icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $3f9c89d5bd82c63b$var$getDefaultUsablePrefix(),
                iconName: $3f9c89d5bd82c63b$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === 'string') {
            var _prefix = $3f9c89d5bd82c63b$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $3f9c89d5bd82c63b$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $3f9c89d5bd82c63b$export$644d8ea042df96a6 = {
    noAuto: $3f9c89d5bd82c63b$var$noAuto,
    config: $3f9c89d5bd82c63b$var$config,
    dom: $3f9c89d5bd82c63b$var$dom,
    parse: $3f9c89d5bd82c63b$var$parse,
    library: $3f9c89d5bd82c63b$var$library,
    findIconDefinition: $3f9c89d5bd82c63b$var$findIconDefinition,
    toHtml: $3f9c89d5bd82c63b$var$toHtml
};
var $3f9c89d5bd82c63b$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $3f9c89d5bd82c63b$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($3f9c89d5bd82c63b$var$namespace.styles).length > 0 || $3f9c89d5bd82c63b$var$config.autoFetchSvg) && $3f9c89d5bd82c63b$var$IS_DOM && $3f9c89d5bd82c63b$var$config.autoReplaceSvg) $3f9c89d5bd82c63b$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $3f9c89d5bd82c63b$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function get() {
            return val.abstract.map(function(a) {
                return $3f9c89d5bd82c63b$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, 'node', {
        get: function get() {
            if (!$3f9c89d5bd82c63b$var$IS_DOM) return;
            var container = $3f9c89d5bd82c63b$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $3f9c89d5bd82c63b$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($3f9c89d5bd82c63b$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $3f9c89d5bd82c63b$var$joinStyles($3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $3f9c89d5bd82c63b$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($3f9c89d5bd82c63b$var$config.familyPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $3f9c89d5bd82c63b$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === 'fak';
    var attrClass = [
        $3f9c89d5bd82c63b$var$config.replacementClass,
        iconName ? "".concat($3f9c89d5bd82c63b$var$config.familyPrefix, "-").concat(iconName) : ''
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
        children: [],
        attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$3f9c89d5bd82c63b$var$DATA_FA_I2SVG] = '';
    if (title) {
        content.children.push({
            tag: 'title',
            attributes: {
                id: content.attributes['aria-labelledby'] || "title-".concat(titleId || $3f9c89d5bd82c63b$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? $3f9c89d5bd82c63b$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $3f9c89d5bd82c63b$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $3f9c89d5bd82c63b$var$asSymbol(args);
    else return $3f9c89d5bd82c63b$var$asIcon(args);
}
function $3f9c89d5bd82c63b$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    if (watchable) attributes[$3f9c89d5bd82c63b$var$DATA_FA_I2SVG] = '';
    var styles = $3f9c89d5bd82c63b$var$_objectSpread2({}, extra.styles);
    if ($3f9c89d5bd82c63b$var$transformIsMeaningful(transform)) {
        styles['transform'] = $3f9c89d5bd82c63b$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    var styleString = $3f9c89d5bd82c63b$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
function $3f9c89d5bd82c63b$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    var styleString = $3f9c89d5bd82c63b$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
var $3f9c89d5bd82c63b$var$styles$1 = $3f9c89d5bd82c63b$var$namespace.styles;
function $3f9c89d5bd82c63b$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $3f9c89d5bd82c63b$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($3f9c89d5bd82c63b$var$config.familyPrefix, "-").concat($3f9c89d5bd82c63b$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($3f9c89d5bd82c63b$var$config.familyPrefix, "-").concat($3f9c89d5bd82c63b$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($3f9c89d5bd82c63b$var$config.familyPrefix, "-").concat($3f9c89d5bd82c63b$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $3f9c89d5bd82c63b$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $3f9c89d5bd82c63b$var$maybeNotifyMissing(iconName, prefix) {
    if (!$3f9c89d5bd82c63b$var$PRODUCTION && !$3f9c89d5bd82c63b$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $3f9c89d5bd82c63b$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === 'fa' && $3f9c89d5bd82c63b$var$config.styleDefault !== null) prefix = $3f9c89d5bd82c63b$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $3f9c89d5bd82c63b$var$callProvided('missingIconAbstract') || {}
        };
        if (givenPrefix === 'fa') {
            var shim = $3f9c89d5bd82c63b$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $3f9c89d5bd82c63b$var$styles$1[prefix] && $3f9c89d5bd82c63b$var$styles$1[prefix][iconName]) {
            var icon = $3f9c89d5bd82c63b$var$styles$1[prefix][iconName];
            return resolve($3f9c89d5bd82c63b$var$asFoundIcon(icon));
        }
        $3f9c89d5bd82c63b$var$maybeNotifyMissing(iconName, prefix);
        resolve($3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, $3f9c89d5bd82c63b$var$missingIconResolutionMixin), {}, {
            icon: $3f9c89d5bd82c63b$var$config.showMissingIcons && iconName ? $3f9c89d5bd82c63b$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
var $3f9c89d5bd82c63b$var$noop$1 = function noop() {};
var $3f9c89d5bd82c63b$var$p = $3f9c89d5bd82c63b$var$config.measurePerformance && $3f9c89d5bd82c63b$var$PERFORMANCE && $3f9c89d5bd82c63b$var$PERFORMANCE.mark && $3f9c89d5bd82c63b$var$PERFORMANCE.measure ? $3f9c89d5bd82c63b$var$PERFORMANCE : {
    mark: $3f9c89d5bd82c63b$var$noop$1,
    measure: $3f9c89d5bd82c63b$var$noop$1
};
var $3f9c89d5bd82c63b$var$preamble = "FA \"6.0.0\"";
var $3f9c89d5bd82c63b$var$begin = function begin(name) {
    $3f9c89d5bd82c63b$var$p.mark("".concat($3f9c89d5bd82c63b$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $3f9c89d5bd82c63b$var$end(name);
    };
};
var $3f9c89d5bd82c63b$var$end = function end(name) {
    $3f9c89d5bd82c63b$var$p.mark("".concat($3f9c89d5bd82c63b$var$preamble, " ").concat(name, " ends"));
    $3f9c89d5bd82c63b$var$p.measure("".concat($3f9c89d5bd82c63b$var$preamble, " ").concat(name), "".concat($3f9c89d5bd82c63b$var$preamble, " ").concat(name, " begins"), "".concat($3f9c89d5bd82c63b$var$preamble, " ").concat(name, " ends"));
};
var $3f9c89d5bd82c63b$var$perf = {
    begin: $3f9c89d5bd82c63b$var$begin,
    end: $3f9c89d5bd82c63b$var$end
};
var $3f9c89d5bd82c63b$var$noop$2 = function noop() {};
function $3f9c89d5bd82c63b$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($3f9c89d5bd82c63b$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $3f9c89d5bd82c63b$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($3f9c89d5bd82c63b$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($3f9c89d5bd82c63b$var$DATA_ICON) : null;
    return prefix && icon;
}
function $3f9c89d5bd82c63b$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($3f9c89d5bd82c63b$var$config.replacementClass);
}
function $3f9c89d5bd82c63b$var$getMutator() {
    if ($3f9c89d5bd82c63b$var$config.autoReplaceSvg === true) return $3f9c89d5bd82c63b$var$mutators.replace;
    var mutator = $3f9c89d5bd82c63b$var$mutators[$3f9c89d5bd82c63b$var$config.autoReplaceSvg];
    return mutator || $3f9c89d5bd82c63b$var$mutators.replace;
}
function $3f9c89d5bd82c63b$var$createElementNS(tag) {
    return $3f9c89d5bd82c63b$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $3f9c89d5bd82c63b$var$createElement(tag) {
    return $3f9c89d5bd82c63b$var$DOCUMENT.createElement(tag);
}
function $3f9c89d5bd82c63b$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? $3f9c89d5bd82c63b$var$createElementNS : $3f9c89d5bd82c63b$var$createElement : _params$ceFn;
    if (typeof abstractObj === 'string') return $3f9c89d5bd82c63b$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($3f9c89d5bd82c63b$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $3f9c89d5bd82c63b$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $3f9c89d5bd82c63b$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(abstract) {
                node.parentNode.insertBefore($3f9c89d5bd82c63b$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($3f9c89d5bd82c63b$var$DATA_FA_I2SVG) === null && $3f9c89d5bd82c63b$var$config.keepOriginalSource) {
                var comment = $3f9c89d5bd82c63b$var$DOCUMENT.createComment($3f9c89d5bd82c63b$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$3f9c89d5bd82c63b$var$classArray(node).indexOf($3f9c89d5bd82c63b$var$config.replacementClass)) return $3f9c89d5bd82c63b$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($3f9c89d5bd82c63b$var$config.familyPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            var splitClasses = abstract[0].attributes.class.split(' ').reduce(function(acc, cls) {
                if (cls === $3f9c89d5bd82c63b$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        var newInnerHTML = abstract.map(function(a) {
            return $3f9c89d5bd82c63b$var$toHtml(a);
        }).join('\n');
        node.setAttribute($3f9c89d5bd82c63b$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $3f9c89d5bd82c63b$var$performOperationSync(op) {
    op();
}
function $3f9c89d5bd82c63b$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === 'function' ? callback : $3f9c89d5bd82c63b$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $3f9c89d5bd82c63b$var$performOperationSync;
        if ($3f9c89d5bd82c63b$var$config.mutateApproach === $3f9c89d5bd82c63b$var$MUTATION_APPROACH_ASYNC) frame = $3f9c89d5bd82c63b$var$WINDOW.requestAnimationFrame || $3f9c89d5bd82c63b$var$performOperationSync;
        frame(function() {
            var mutator = $3f9c89d5bd82c63b$var$getMutator();
            var mark = $3f9c89d5bd82c63b$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $3f9c89d5bd82c63b$var$disabled = false;
function $3f9c89d5bd82c63b$var$disableObservation() {
    $3f9c89d5bd82c63b$var$disabled = true;
}
function $3f9c89d5bd82c63b$var$enableObservation() {
    $3f9c89d5bd82c63b$var$disabled = false;
}
var $3f9c89d5bd82c63b$var$mo = null;
function $3f9c89d5bd82c63b$var$observe(options) {
    if (!$3f9c89d5bd82c63b$var$MUTATION_OBSERVER) return;
    if (!$3f9c89d5bd82c63b$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $3f9c89d5bd82c63b$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $3f9c89d5bd82c63b$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $3f9c89d5bd82c63b$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $3f9c89d5bd82c63b$var$DOCUMENT : _options$observeMutat;
    $3f9c89d5bd82c63b$var$mo = new $3f9c89d5bd82c63b$var$MUTATION_OBSERVER(function(objects) {
        if ($3f9c89d5bd82c63b$var$disabled) return;
        var defaultPrefix = $3f9c89d5bd82c63b$var$getDefaultUsablePrefix();
        $3f9c89d5bd82c63b$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$3f9c89d5bd82c63b$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($3f9c89d5bd82c63b$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $3f9c89d5bd82c63b$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === 'attributes' && $3f9c89d5bd82c63b$var$isWatched(mutationRecord.target) && ~$3f9c89d5bd82c63b$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $3f9c89d5bd82c63b$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $3f9c89d5bd82c63b$var$getCanonicalIcon($3f9c89d5bd82c63b$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($3f9c89d5bd82c63b$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($3f9c89d5bd82c63b$var$DATA_ICON, iconName);
                } else if ($3f9c89d5bd82c63b$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$3f9c89d5bd82c63b$var$IS_DOM) return;
    $3f9c89d5bd82c63b$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $3f9c89d5bd82c63b$var$disconnect() {
    if (!$3f9c89d5bd82c63b$var$mo) return;
    $3f9c89d5bd82c63b$var$mo.disconnect();
}
function $3f9c89d5bd82c63b$var$styleParser(node) {
    var style = node.getAttribute('style');
    var val = [];
    if (style) val = style.split(';').reduce(function(acc, style) {
        var styles = style.split(':');
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $3f9c89d5bd82c63b$var$classParser(node) {
    var existingPrefix = node.getAttribute('data-prefix');
    var existingIconName = node.getAttribute('data-icon');
    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    var val = $3f9c89d5bd82c63b$var$getCanonicalIcon($3f9c89d5bd82c63b$var$classArray(node));
    if (!val.prefix) val.prefix = $3f9c89d5bd82c63b$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $3f9c89d5bd82c63b$var$byLigature(val.prefix, node.innerText) || $3f9c89d5bd82c63b$var$byUnicode(val.prefix, $3f9c89d5bd82c63b$var$toHex(node.innerText));
    return val;
}
function $3f9c89d5bd82c63b$var$attributesParser(node) {
    var extraAttributes = $3f9c89d5bd82c63b$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute('title');
    var titleId = node.getAttribute('data-fa-title-id');
    if ($3f9c89d5bd82c63b$var$config.autoA11y) {
        if (title) extraAttributes['aria-labelledby'] = "".concat($3f9c89d5bd82c63b$var$config.replacementClass, "-title-").concat(titleId || $3f9c89d5bd82c63b$var$nextUniqueId());
        else {
            extraAttributes['aria-hidden'] = 'true';
            extraAttributes['focusable'] = 'false';
        }
    }
    return extraAttributes;
}
function $3f9c89d5bd82c63b$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $3f9c89d5bd82c63b$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $3f9c89d5bd82c63b$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $3f9c89d5bd82c63b$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $3f9c89d5bd82c63b$var$attributesParser(node);
    var pluginMeta = $3f9c89d5bd82c63b$var$chainHooks('parseNodeAttributes', {}, node);
    var extraStyles = parser.styleParser ? $3f9c89d5bd82c63b$var$styleParser(node) : [];
    return $3f9c89d5bd82c63b$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute('title'),
        titleId: node.getAttribute('data-fa-title-id'),
        prefix: prefix,
        transform: $3f9c89d5bd82c63b$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $3f9c89d5bd82c63b$var$styles$2 = $3f9c89d5bd82c63b$var$namespace.styles;
function $3f9c89d5bd82c63b$var$generateMutation(node) {
    var nodeMeta = $3f9c89d5bd82c63b$var$config.autoReplaceSvg === 'nest' ? $3f9c89d5bd82c63b$var$parseMeta(node, {
        styleParser: false
    }) : $3f9c89d5bd82c63b$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($3f9c89d5bd82c63b$var$LAYERS_TEXT_CLASSNAME)) return $3f9c89d5bd82c63b$var$callProvided('generateLayersText', node, nodeMeta);
    else return $3f9c89d5bd82c63b$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
function $3f9c89d5bd82c63b$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$3f9c89d5bd82c63b$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $3f9c89d5bd82c63b$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($3f9c89d5bd82c63b$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($3f9c89d5bd82c63b$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $3f9c89d5bd82c63b$var$config.autoFetchSvg ? Object.keys($3f9c89d5bd82c63b$var$PREFIX_TO_STYLE) : Object.keys($3f9c89d5bd82c63b$var$styles$2);
    var prefixesDomQuery = [
        ".".concat($3f9c89d5bd82c63b$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($3f9c89d5bd82c63b$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($3f9c89d5bd82c63b$var$DATA_FA_I2SVG, "])");
    })).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $3f9c89d5bd82c63b$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    var mark = $3f9c89d5bd82c63b$var$perf.begin('onTree');
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $3f9c89d5bd82c63b$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$3f9c89d5bd82c63b$var$PRODUCTION) {
                if (e.name === 'MissingIcon') console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $3f9c89d5bd82c63b$var$perform(resolvedMutations, function() {
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function $3f9c89d5bd82c63b$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $3f9c89d5bd82c63b$var$generateMutation(node).then(function(mutation) {
        if (mutation) $3f9c89d5bd82c63b$var$perform([
            mutation
        ], callback);
    });
}
function $3f9c89d5bd82c63b$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $3f9c89d5bd82c63b$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $3f9c89d5bd82c63b$var$findIconDefinition(mask || {});
        return next(iconDefinition, $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $3f9c89d5bd82c63b$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $3f9c89d5bd82c63b$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $3f9c89d5bd82c63b$var$domVariants($3f9c89d5bd82c63b$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), function() {
        $3f9c89d5bd82c63b$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($3f9c89d5bd82c63b$var$config.autoA11y) {
            if (title) attributes['aria-labelledby'] = "".concat($3f9c89d5bd82c63b$var$config.replacementClass, "-title-").concat(titleId || $3f9c89d5bd82c63b$var$nextUniqueId());
            else {
                attributes['aria-hidden'] = 'true';
                attributes['focusable'] = 'false';
            }
        }
        return $3f9c89d5bd82c63b$var$makeInlineSvgAbstract({
            icons: {
                main: $3f9c89d5bd82c63b$var$asFoundIcon(icon),
                mask: mask ? $3f9c89d5bd82c63b$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, $3f9c89d5bd82c63b$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $3f9c89d5bd82c63b$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $3f9c89d5bd82c63b$var$resolveIcons($3f9c89d5bd82c63b$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $3f9c89d5bd82c63b$var$onTree;
                accumulator.nodeCallback = $3f9c89d5bd82c63b$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $3f9c89d5bd82c63b$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return $3f9c89d5bd82c63b$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $3f9c89d5bd82c63b$var$findIcon(iconName, prefix),
                    mask.iconName ? $3f9c89d5bd82c63b$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $3f9c89d5bd82c63b$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $3f9c89d5bd82c63b$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $3f9c89d5bd82c63b$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            var nextChild;
            if ($3f9c89d5bd82c63b$var$transformIsMeaningful(transform)) nextChild = $3f9c89d5bd82c63b$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $3f9c89d5bd82c63b$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $3f9c89d5bd82c63b$var$domVariants({
                    type: 'layer'
                }, function() {
                    $3f9c89d5bd82c63b$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($3f9c89d5bd82c63b$var$config.familyPrefix, "-layers")
                                ].concat($3f9c89d5bd82c63b$var$_toConsumableArray(classes)).join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $3f9c89d5bd82c63b$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $3f9c89d5bd82c63b$var$domVariants({
                    type: 'counter',
                    content: content
                }, function() {
                    $3f9c89d5bd82c63b$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $3f9c89d5bd82c63b$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($3f9c89d5bd82c63b$var$config.familyPrefix, "-layers-counter")
                            ].concat($3f9c89d5bd82c63b$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $3f9c89d5bd82c63b$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $3f9c89d5bd82c63b$var$meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $3f9c89d5bd82c63b$var$domVariants({
                    type: 'text',
                    content: content
                }, function() {
                    $3f9c89d5bd82c63b$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $3f9c89d5bd82c63b$var$makeLayersTextAbstract({
                        content: content,
                        transform: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, $3f9c89d5bd82c63b$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($3f9c89d5bd82c63b$var$config.familyPrefix, "-layers-text")
                            ].concat($3f9c89d5bd82c63b$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($3f9c89d5bd82c63b$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($3f9c89d5bd82c63b$var$config.autoA11y && !title) extra.attributes['aria-hidden'] = 'true';
            return Promise.resolve([
                node,
                $3f9c89d5bd82c63b$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $3f9c89d5bd82c63b$var$CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var $3f9c89d5bd82c63b$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function $3f9c89d5bd82c63b$var$hexValueFromContent(content) {
    var cleaned = content.replace($3f9c89d5bd82c63b$var$CLEAN_CONTENT_PATTERN, '');
    var codePoint = $3f9c89d5bd82c63b$var$codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= $3f9c89d5bd82c63b$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $3f9c89d5bd82c63b$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $3f9c89d5bd82c63b$var$toHex(cleaned[0]) : $3f9c89d5bd82c63b$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $3f9c89d5bd82c63b$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($3f9c89d5bd82c63b$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $3f9c89d5bd82c63b$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($3f9c89d5bd82c63b$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $3f9c89d5bd82c63b$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue('font-family').match($3f9c89d5bd82c63b$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue('font-weight');
        var content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== 'none' && content !== '') {
            var _content = styles.getPropertyValue('content');
            var prefix = ~[
                'Solid',
                'Regular',
                'Light',
                'Thin',
                'Duotone',
                'Brands',
                'Kit'
            ].indexOf(fontFamily[2]) ? $3f9c89d5bd82c63b$var$STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : $3f9c89d5bd82c63b$var$FONT_WEIGHT_TO_PREFIX[fontWeight];
            var _hexValueFromContent = $3f9c89d5bd82c63b$var$hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith('FontAwesome');
            var iconName = $3f9c89d5bd82c63b$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $3f9c89d5bd82c63b$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($3f9c89d5bd82c63b$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($3f9c89d5bd82c63b$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $3f9c89d5bd82c63b$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$3f9c89d5bd82c63b$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $3f9c89d5bd82c63b$var$findIcon(iconName, prefix).then(function(main) {
                    var abstract = $3f9c89d5bd82c63b$var$makeInlineSvgAbstract($3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $3f9c89d5bd82c63b$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $3f9c89d5bd82c63b$var$DOCUMENT.createElement('svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a) {
                        return $3f9c89d5bd82c63b$var$toHtml(a);
                    }).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $3f9c89d5bd82c63b$var$replace(node) {
    return Promise.all([
        $3f9c89d5bd82c63b$var$replaceForPosition(node, '::before'),
        $3f9c89d5bd82c63b$var$replaceForPosition(node, '::after')
    ]);
}
function $3f9c89d5bd82c63b$var$processable(node) {
    return node.parentNode !== document.head && !~$3f9c89d5bd82c63b$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($3f9c89d5bd82c63b$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function $3f9c89d5bd82c63b$var$searchPseudoElements(root) {
    if (!$3f9c89d5bd82c63b$var$IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = $3f9c89d5bd82c63b$var$toArray(root.querySelectorAll('*')).filter($3f9c89d5bd82c63b$var$processable).map($3f9c89d5bd82c63b$var$replace);
        var end = $3f9c89d5bd82c63b$var$perf.begin('searchPseudoElements');
        $3f9c89d5bd82c63b$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $3f9c89d5bd82c63b$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $3f9c89d5bd82c63b$var$enableObservation();
            reject();
        });
    });
}
var $3f9c89d5bd82c63b$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $3f9c89d5bd82c63b$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $3f9c89d5bd82c63b$var$DOCUMENT : _params$node;
            if ($3f9c89d5bd82c63b$var$config.searchPseudoElements) $3f9c89d5bd82c63b$var$searchPseudoElements(node);
        };
    }
};
var $3f9c89d5bd82c63b$var$_unwatched = false;
var $3f9c89d5bd82c63b$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $3f9c89d5bd82c63b$var$disableObservation();
                    $3f9c89d5bd82c63b$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $3f9c89d5bd82c63b$var$observe($3f9c89d5bd82c63b$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto: function noAuto() {
                $3f9c89d5bd82c63b$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($3f9c89d5bd82c63b$var$_unwatched) $3f9c89d5bd82c63b$var$enableObservation();
                else $3f9c89d5bd82c63b$var$observe($3f9c89d5bd82c63b$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $3f9c89d5bd82c63b$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce(function(acc, n) {
        var parts = n.toLowerCase().split('-');
        var first = parts[0];
        var rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $3f9c89d5bd82c63b$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $3f9c89d5bd82c63b$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $3f9c89d5bd82c63b$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $3f9c89d5bd82c63b$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $3f9c89d5bd82c63b$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $3f9c89d5bd82c63b$var$fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function $3f9c89d5bd82c63b$var$deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var $3f9c89d5bd82c63b$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute('data-fa-mask');
                var mask = !maskData ? $3f9c89d5bd82c63b$var$emptyCanonicalIcon() : $3f9c89d5bd82c63b$var$getCanonicalIcon(maskData.split(' ').map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $3f9c89d5bd82c63b$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $3f9c89d5bd82c63b$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: 'rect',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, $3f9c89d5bd82c63b$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($3f9c89d5bd82c63b$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: 'g',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2({}, trans.inner),
                children: [
                    $3f9c89d5bd82c63b$var$fillBlack($3f9c89d5bd82c63b$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: 'g',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $3f9c89d5bd82c63b$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $3f9c89d5bd82c63b$var$nextUniqueId());
            var maskTag = {
                tag: 'mask',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, $3f9c89d5bd82c63b$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $3f9c89d5bd82c63b$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2({
                    fill: 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $3f9c89d5bd82c63b$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $3f9c89d5bd82c63b$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($3f9c89d5bd82c63b$var$WINDOW.matchMedia) reduceMotion = $3f9c89d5bd82c63b$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: 'currentColor'
            };
            var ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            }; // Ring
            gChildren.push({
                tag: 'path',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            var OPACITY_ANIMATE = $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            var dot = {
                tag: 'circle',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $3f9c89d5bd82c63b$var$_objectSpread2($3f9c89d5bd82c63b$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    'class': 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $3f9c89d5bd82c63b$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute('data-fa-symbol');
                var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $3f9c89d5bd82c63b$var$plugins = [
    $3f9c89d5bd82c63b$var$InjectCSS,
    $3f9c89d5bd82c63b$var$ReplaceElements,
    $3f9c89d5bd82c63b$var$Layers,
    $3f9c89d5bd82c63b$var$LayersCounter,
    $3f9c89d5bd82c63b$var$LayersText,
    $3f9c89d5bd82c63b$var$PseudoElements,
    $3f9c89d5bd82c63b$var$MutationObserver$1,
    $3f9c89d5bd82c63b$var$PowerTransforms,
    $3f9c89d5bd82c63b$var$Masks,
    $3f9c89d5bd82c63b$var$MissingIconIndicator,
    $3f9c89d5bd82c63b$var$SvgSymbols
];
$3f9c89d5bd82c63b$var$registerPlugins($3f9c89d5bd82c63b$var$plugins, {
    mixoutsTo: $3f9c89d5bd82c63b$export$644d8ea042df96a6
});
var $3f9c89d5bd82c63b$export$4f8e844b2782642c = $3f9c89d5bd82c63b$export$644d8ea042df96a6.noAuto;
var $3f9c89d5bd82c63b$export$e506a1d27d1eaa20 = $3f9c89d5bd82c63b$export$644d8ea042df96a6.config;
var $3f9c89d5bd82c63b$export$b839f963c7dc0e34 = $3f9c89d5bd82c63b$export$644d8ea042df96a6.library;
var $3f9c89d5bd82c63b$export$df3a06d6289f983e = $3f9c89d5bd82c63b$export$644d8ea042df96a6.dom;
var $3f9c89d5bd82c63b$export$98e6a39c04603d36 = $3f9c89d5bd82c63b$export$644d8ea042df96a6.parse;
var $3f9c89d5bd82c63b$export$221fed4a47f597a5 = $3f9c89d5bd82c63b$export$644d8ea042df96a6.findIconDefinition;
var $3f9c89d5bd82c63b$export$a10125c086a4df16 = $3f9c89d5bd82c63b$export$644d8ea042df96a6.toHtml;
var $3f9c89d5bd82c63b$export$1ca1ec8b29a4ce27 = $3f9c89d5bd82c63b$export$644d8ea042df96a6.icon;
var $3f9c89d5bd82c63b$export$50a222d9023da98b = $3f9c89d5bd82c63b$export$644d8ea042df96a6.layer;
var $3f9c89d5bd82c63b$export$6f093cfa640b7166 = $3f9c89d5bd82c63b$export$644d8ea042df96a6.text;
var $3f9c89d5bd82c63b$export$e575061ef2a070eb = $3f9c89d5bd82c63b$export$644d8ea042df96a6.counter;


var $70c832aff9838e04$exports = {};
'use strict';
Object.defineProperty($70c832aff9838e04$exports, '__esModule', {
    value: true
});
var $70c832aff9838e04$var$prefix = 'fal';
var $70c832aff9838e04$var$iconName = 'building';
var $70c832aff9838e04$var$width = 448;
var $70c832aff9838e04$var$height = 512;
var $70c832aff9838e04$var$ligatures = [];
var $70c832aff9838e04$var$unicode = 'f1ad';
var $70c832aff9838e04$var$svgPathData = 'M192 107v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12zm116-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm140 205v20H0v-20c0-6.627 5.373-12 12-12h20V24C32 10.745 42.745 0 56 0h336c13.255 0 24 10.745 24 24v456h20c6.627 0 12 5.373 12 12zm-64-12V32H64v448h128v-85c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v85h128z';
$70c832aff9838e04$exports.definition = {
    prefix: $70c832aff9838e04$var$prefix,
    iconName: $70c832aff9838e04$var$iconName,
    icon: [
        $70c832aff9838e04$var$width,
        $70c832aff9838e04$var$height,
        $70c832aff9838e04$var$ligatures,
        $70c832aff9838e04$var$unicode,
        $70c832aff9838e04$var$svgPathData
    ]
};
$70c832aff9838e04$exports.faBuilding = $70c832aff9838e04$exports.definition;
$70c832aff9838e04$exports.prefix = $70c832aff9838e04$var$prefix;
$70c832aff9838e04$exports.iconName = $70c832aff9838e04$var$iconName;
$70c832aff9838e04$exports.width = $70c832aff9838e04$var$width;
$70c832aff9838e04$exports.height = $70c832aff9838e04$var$height;
$70c832aff9838e04$exports.ligatures = $70c832aff9838e04$var$ligatures;
$70c832aff9838e04$exports.unicode = $70c832aff9838e04$var$unicode;
$70c832aff9838e04$exports.svgPathData = $70c832aff9838e04$var$svgPathData;


var $37a2f4da76dab7ae$exports = {};
'use strict';
Object.defineProperty($37a2f4da76dab7ae$exports, '__esModule', {
    value: true
});
var $37a2f4da76dab7ae$var$prefix = 'fal';
var $37a2f4da76dab7ae$var$iconName = 'envelope';
var $37a2f4da76dab7ae$var$width = 512;
var $37a2f4da76dab7ae$var$height = 512;
var $37a2f4da76dab7ae$var$ligatures = [];
var $37a2f4da76dab7ae$var$unicode = 'f0e0';
var $37a2f4da76dab7ae$var$svgPathData = 'M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z';
$37a2f4da76dab7ae$exports.definition = {
    prefix: $37a2f4da76dab7ae$var$prefix,
    iconName: $37a2f4da76dab7ae$var$iconName,
    icon: [
        $37a2f4da76dab7ae$var$width,
        $37a2f4da76dab7ae$var$height,
        $37a2f4da76dab7ae$var$ligatures,
        $37a2f4da76dab7ae$var$unicode,
        $37a2f4da76dab7ae$var$svgPathData
    ]
};
$37a2f4da76dab7ae$exports.faEnvelope = $37a2f4da76dab7ae$exports.definition;
$37a2f4da76dab7ae$exports.prefix = $37a2f4da76dab7ae$var$prefix;
$37a2f4da76dab7ae$exports.iconName = $37a2f4da76dab7ae$var$iconName;
$37a2f4da76dab7ae$exports.width = $37a2f4da76dab7ae$var$width;
$37a2f4da76dab7ae$exports.height = $37a2f4da76dab7ae$var$height;
$37a2f4da76dab7ae$exports.ligatures = $37a2f4da76dab7ae$var$ligatures;
$37a2f4da76dab7ae$exports.unicode = $37a2f4da76dab7ae$var$unicode;
$37a2f4da76dab7ae$exports.svgPathData = $37a2f4da76dab7ae$var$svgPathData;


var $79399fc6e150411b$exports = {};
'use strict';
Object.defineProperty($79399fc6e150411b$exports, '__esModule', {
    value: true
});
var $79399fc6e150411b$var$prefix = 'fal';
var $79399fc6e150411b$var$iconName = 'key';
var $79399fc6e150411b$var$width = 512;
var $79399fc6e150411b$var$height = 512;
var $79399fc6e150411b$var$ligatures = [];
var $79399fc6e150411b$var$unicode = 'f084';
var $79399fc6e150411b$var$svgPathData = 'M336 32c79.529 0 144 64.471 144 144s-64.471 144-144 144c-18.968 0-37.076-3.675-53.661-10.339L240 352h-48v64h-64v64H32v-80l170.339-170.339C195.675 213.076 192 194.968 192 176c0-79.529 64.471-144 144-144m0-32c-97.184 0-176 78.769-176 176 0 15.307 1.945 30.352 5.798 44.947L7.029 379.716A24.003 24.003 0 0 0 0 396.686V488c0 13.255 10.745 24 24 24h112c13.255 0 24-10.745 24-24v-40h40c13.255 0 24-10.745 24-24v-40h19.314c6.365 0 12.47-2.529 16.971-7.029l30.769-30.769C305.648 350.055 320.693 352 336 352c97.184 0 176-78.769 176-176C512 78.816 433.231 0 336 0zm48 108c11.028 0 20 8.972 20 20s-8.972 20-20 20-20-8.972-20-20 8.972-20 20-20m0-28c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z';
$79399fc6e150411b$exports.definition = {
    prefix: $79399fc6e150411b$var$prefix,
    iconName: $79399fc6e150411b$var$iconName,
    icon: [
        $79399fc6e150411b$var$width,
        $79399fc6e150411b$var$height,
        $79399fc6e150411b$var$ligatures,
        $79399fc6e150411b$var$unicode,
        $79399fc6e150411b$var$svgPathData
    ]
};
$79399fc6e150411b$exports.faKey = $79399fc6e150411b$exports.definition;
$79399fc6e150411b$exports.prefix = $79399fc6e150411b$var$prefix;
$79399fc6e150411b$exports.iconName = $79399fc6e150411b$var$iconName;
$79399fc6e150411b$exports.width = $79399fc6e150411b$var$width;
$79399fc6e150411b$exports.height = $79399fc6e150411b$var$height;
$79399fc6e150411b$exports.ligatures = $79399fc6e150411b$var$ligatures;
$79399fc6e150411b$exports.unicode = $79399fc6e150411b$var$unicode;
$79399fc6e150411b$exports.svgPathData = $79399fc6e150411b$var$svgPathData;


var $80fb4c4361dbe10b$exports = {};
'use strict';
Object.defineProperty($80fb4c4361dbe10b$exports, '__esModule', {
    value: true
});
var $80fb4c4361dbe10b$var$prefix = 'fal';
var $80fb4c4361dbe10b$var$iconName = 'map-marker';
var $80fb4c4361dbe10b$var$width = 384;
var $80fb4c4361dbe10b$var$height = 512;
var $80fb4c4361dbe10b$var$ligatures = [];
var $80fb4c4361dbe10b$var$unicode = 'f041';
var $80fb4c4361dbe10b$var$svgPathData = 'M192 0C85.961 0 0 85.961 0 192c0 77.413 26.97 99.031 172.268 309.67 9.534 13.772 29.929 13.774 39.465 0C357.03 291.031 384 269.413 384 192 384 85.961 298.039 0 192 0zm0 473.931C52.705 272.488 32 256.494 32 192c0-42.738 16.643-82.917 46.863-113.137S149.262 32 192 32s82.917 16.643 113.137 46.863S352 149.262 352 192c0 64.49-20.692 80.47-160 281.931z';
$80fb4c4361dbe10b$exports.definition = {
    prefix: $80fb4c4361dbe10b$var$prefix,
    iconName: $80fb4c4361dbe10b$var$iconName,
    icon: [
        $80fb4c4361dbe10b$var$width,
        $80fb4c4361dbe10b$var$height,
        $80fb4c4361dbe10b$var$ligatures,
        $80fb4c4361dbe10b$var$unicode,
        $80fb4c4361dbe10b$var$svgPathData
    ]
};
$80fb4c4361dbe10b$exports.faMapMarker = $80fb4c4361dbe10b$exports.definition;
$80fb4c4361dbe10b$exports.prefix = $80fb4c4361dbe10b$var$prefix;
$80fb4c4361dbe10b$exports.iconName = $80fb4c4361dbe10b$var$iconName;
$80fb4c4361dbe10b$exports.width = $80fb4c4361dbe10b$var$width;
$80fb4c4361dbe10b$exports.height = $80fb4c4361dbe10b$var$height;
$80fb4c4361dbe10b$exports.ligatures = $80fb4c4361dbe10b$var$ligatures;
$80fb4c4361dbe10b$exports.unicode = $80fb4c4361dbe10b$var$unicode;
$80fb4c4361dbe10b$exports.svgPathData = $80fb4c4361dbe10b$var$svgPathData;


var $63c5c3dcaa0cecdb$exports = {};
'use strict';
Object.defineProperty($63c5c3dcaa0cecdb$exports, '__esModule', {
    value: true
});
var $63c5c3dcaa0cecdb$var$prefix = 'fal';
var $63c5c3dcaa0cecdb$var$iconName = 'times';
var $63c5c3dcaa0cecdb$var$width = 320;
var $63c5c3dcaa0cecdb$var$height = 512;
var $63c5c3dcaa0cecdb$var$ligatures = [];
var $63c5c3dcaa0cecdb$var$unicode = 'f00d';
var $63c5c3dcaa0cecdb$var$svgPathData = 'M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z';
$63c5c3dcaa0cecdb$exports.definition = {
    prefix: $63c5c3dcaa0cecdb$var$prefix,
    iconName: $63c5c3dcaa0cecdb$var$iconName,
    icon: [
        $63c5c3dcaa0cecdb$var$width,
        $63c5c3dcaa0cecdb$var$height,
        $63c5c3dcaa0cecdb$var$ligatures,
        $63c5c3dcaa0cecdb$var$unicode,
        $63c5c3dcaa0cecdb$var$svgPathData
    ]
};
$63c5c3dcaa0cecdb$exports.faTimes = $63c5c3dcaa0cecdb$exports.definition;
$63c5c3dcaa0cecdb$exports.prefix = $63c5c3dcaa0cecdb$var$prefix;
$63c5c3dcaa0cecdb$exports.iconName = $63c5c3dcaa0cecdb$var$iconName;
$63c5c3dcaa0cecdb$exports.width = $63c5c3dcaa0cecdb$var$width;
$63c5c3dcaa0cecdb$exports.height = $63c5c3dcaa0cecdb$var$height;
$63c5c3dcaa0cecdb$exports.ligatures = $63c5c3dcaa0cecdb$var$ligatures;
$63c5c3dcaa0cecdb$exports.unicode = $63c5c3dcaa0cecdb$var$unicode;
$63c5c3dcaa0cecdb$exports.svgPathData = $63c5c3dcaa0cecdb$var$svgPathData;


var $f07d754c5fcdb048$exports = {};
'use strict';
Object.defineProperty($f07d754c5fcdb048$exports, '__esModule', {
    value: true
});
var $f07d754c5fcdb048$var$prefix = 'fab';
var $f07d754c5fcdb048$var$iconName = 'github';
var $f07d754c5fcdb048$var$width = 496;
var $f07d754c5fcdb048$var$height = 512;
var $f07d754c5fcdb048$var$ligatures = [];
var $f07d754c5fcdb048$var$unicode = 'f09b';
var $f07d754c5fcdb048$var$svgPathData = 'M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z';
$f07d754c5fcdb048$exports.definition = {
    prefix: $f07d754c5fcdb048$var$prefix,
    iconName: $f07d754c5fcdb048$var$iconName,
    icon: [
        $f07d754c5fcdb048$var$width,
        $f07d754c5fcdb048$var$height,
        $f07d754c5fcdb048$var$ligatures,
        $f07d754c5fcdb048$var$unicode,
        $f07d754c5fcdb048$var$svgPathData
    ]
};
$f07d754c5fcdb048$exports.faGithub = $f07d754c5fcdb048$exports.definition;
$f07d754c5fcdb048$exports.prefix = $f07d754c5fcdb048$var$prefix;
$f07d754c5fcdb048$exports.iconName = $f07d754c5fcdb048$var$iconName;
$f07d754c5fcdb048$exports.width = $f07d754c5fcdb048$var$width;
$f07d754c5fcdb048$exports.height = $f07d754c5fcdb048$var$height;
$f07d754c5fcdb048$exports.ligatures = $f07d754c5fcdb048$var$ligatures;
$f07d754c5fcdb048$exports.unicode = $f07d754c5fcdb048$var$unicode;
$f07d754c5fcdb048$exports.svgPathData = $f07d754c5fcdb048$var$svgPathData;


var $598210a13e12df14$exports = {};
'use strict';
Object.defineProperty($598210a13e12df14$exports, '__esModule', {
    value: true
});
var $598210a13e12df14$var$prefix = 'fab';
var $598210a13e12df14$var$iconName = 'linkedin';
var $598210a13e12df14$var$width = 448;
var $598210a13e12df14$var$height = 512;
var $598210a13e12df14$var$ligatures = [];
var $598210a13e12df14$var$unicode = 'f08c';
var $598210a13e12df14$var$svgPathData = 'M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z';
$598210a13e12df14$exports.definition = {
    prefix: $598210a13e12df14$var$prefix,
    iconName: $598210a13e12df14$var$iconName,
    icon: [
        $598210a13e12df14$var$width,
        $598210a13e12df14$var$height,
        $598210a13e12df14$var$ligatures,
        $598210a13e12df14$var$unicode,
        $598210a13e12df14$var$svgPathData
    ]
};
$598210a13e12df14$exports.faLinkedin = $598210a13e12df14$exports.definition;
$598210a13e12df14$exports.prefix = $598210a13e12df14$var$prefix;
$598210a13e12df14$exports.iconName = $598210a13e12df14$var$iconName;
$598210a13e12df14$exports.width = $598210a13e12df14$var$width;
$598210a13e12df14$exports.height = $598210a13e12df14$var$height;
$598210a13e12df14$exports.ligatures = $598210a13e12df14$var$ligatures;
$598210a13e12df14$exports.unicode = $598210a13e12df14$var$unicode;
$598210a13e12df14$exports.svgPathData = $598210a13e12df14$var$svgPathData;


const $12c0e3e926cd0d31$var$WAIT_WHEN_COMPLETE = 1500;
const $12c0e3e926cd0d31$var$WAIT_WHEN_EMPTY = 750;
const $12c0e3e926cd0d31$var$TYPE_FREQUENCY = 120;
const $12c0e3e926cd0d31$var$CURSOR_BLINK_FREQUENCY = 400;
(0, $3f9c89d5bd82c63b$export$b839f963c7dc0e34).add((0, $70c832aff9838e04$exports.faBuilding), (0, $37a2f4da76dab7ae$exports.faEnvelope), (0, $f07d754c5fcdb048$exports.faGithub), (0, $79399fc6e150411b$exports.faKey), (0, $598210a13e12df14$exports.faLinkedin), (0, $80fb4c4361dbe10b$exports.faMapMarker), (0, $63c5c3dcaa0cecdb$exports.faTimes));
(0, $3f9c89d5bd82c63b$export$df3a06d6289f983e).watch();
const $12c0e3e926cd0d31$var$ROLE_SUFFIXES = /\b(Developer|Expert|Engineer|Pro|Architect|Enthusiast|Alumnus)\s*$/i;
const $12c0e3e926cd0d31$var$getRole = (word)=>{
    const match = word.trim().match($12c0e3e926cd0d31$var$ROLE_SUFFIXES);
    return match ? match[1].toLowerCase() : null;
};
const $12c0e3e926cd0d31$var$shuffle = (a)=>{
    for(let i = a.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [
            a[j],
            a[i]
        ];
    }
    // Reshuffle until no two adjacent entries share a role suffix
    for(let i = 1; i < a.length; i++){
        const prev = $12c0e3e926cd0d31$var$getRole(a[i - 1]);
        const curr = $12c0e3e926cd0d31$var$getRole(a[i]);
        if (prev && curr && prev === curr) // Find a non-conflicting swap candidate further ahead
        for(let j = i + 1; j < a.length; j++){
            const candidate = $12c0e3e926cd0d31$var$getRole(a[j]);
            if (candidate !== prev && (i + 1 >= a.length || candidate !== $12c0e3e926cd0d31$var$getRole(a[i + 1]))) {
                [a[i], a[j]] = [
                    a[j],
                    a[i]
                ];
                break;
            }
        }
    }
    return a;
};
const $12c0e3e926cd0d31$var$$ = function(query) {
    let res = document.querySelectorAll(query);
    return res.length > 1 ? res : res[0];
};
window.onload = function() {
    const $hiddenClassName = "hidden";
    const $mainContainer = $12c0e3e926cd0d31$var$$("#main-container");
    const $privacyContainer = $12c0e3e926cd0d31$var$$("#privacy-container");
    const $cursor = $12c0e3e926cd0d31$var$$("#cursor");
    const $textRotation = $12c0e3e926cd0d31$var$$("#textrotation");
    const colors = [
        "#000"
    ];
    const words = $textRotation.innerHTML.replace(/\s{4}/g, "").split(",");
    $12c0e3e926cd0d31$var$shuffle(words);
    $textRotation.innerHTML = "";
    var letterCount = 1;
    var waiting = false;
    var isRemoving = false;
    $textRotation.setAttribute("style", "color:" + colors[0]);
    setInterval(()=>{
        if (waiting) return;
        if (letterCount < 0 && isRemoving) {
            waiting = true;
            // Select new Word
            setTimeout(()=>{
                var usedColor = colors.shift();
                colors.push(usedColor);
                var usedWord = words.shift();
                words.push(usedWord);
                $textRotation.setAttribute("style", "color:" + colors[0]);
                isRemoving = false;
                waiting = false;
            }, $12c0e3e926cd0d31$var$WAIT_WHEN_EMPTY);
        } else if (letterCount === words[0].length + 1 && !isRemoving) {
            waiting = true;
            // Start Removing
            setTimeout(()=>{
                isRemoving = true;
                waiting = false;
            }, $12c0e3e926cd0d31$var$WAIT_WHEN_COMPLETE);
        } else {
            $textRotation.innerHTML = words[0].substring(0, letterCount);
            letterCount += isRemoving ? -1 : 1;
        }
    }, $12c0e3e926cd0d31$var$TYPE_FREQUENCY);
    // Underscore Rendering
    setInterval(()=>{
        $cursor.classList.toggle("visually-hidden");
    }, $12c0e3e926cd0d31$var$CURSOR_BLINK_FREQUENCY);
    $12c0e3e926cd0d31$var$$("#privacy-button").addEventListener("click", function() {
        $mainContainer.classList.add($hiddenClassName);
        $privacyContainer.classList.remove($hiddenClassName);
    });
    $12c0e3e926cd0d31$var$$("#privacy-back-button").addEventListener("click", function() {
        $mainContainer.classList.remove($hiddenClassName);
        $privacyContainer.classList.add($hiddenClassName);
    });
};


//# sourceMappingURL=app.a8cca9ee.js.map
